import APIURLConstants from "../common/ApiURLConstants";
import APIHelper from "../common/ApiHelper";
import { authHeader } from "../helper";

export const TeamPlayerServices = {
  getEventGames,
  addEventGame,
  updateEventGame,
  deleteEventGame,
  getEventGameTeams,
  addEventGameTeam,
  updateEventGameTeam,
  deleteEventGameTeam,
  getEventGameTeamPlayers,
  updateEventGameTeamPlayers,
  getTeamRostersByEnum,
  isDisplayTeamRosterByEnum,
};

async function getEventGames(eventId) {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_EVENT_GAMES}?EventId=${eventId}`,
    authHeader()
  );
  return response;
}

async function addEventGame(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_EVENT_GAME}`,
    formObj,
    authHeader()
  );
  return response;
}

async function updateEventGame(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.UPDATE_EVENT_GAME}`,
    formObj,
    authHeader()
  );
  return response;
}

async function deleteEventGame(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.DELETE_EVENT_GAME}`,
    formObj,
    authHeader()
  );
  return response;
}

async function getEventGameTeams(eventGameId) {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_EVENT_GAME_TEAMS}?EventGameId=${eventGameId}`,
    authHeader()
  );
  return response;
}

async function addEventGameTeam(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_EVENT_GAME_TEAM}`,
    formObj,
    authHeader()
  );
  return response;
}

async function updateEventGameTeam(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.UPDATE_EVENT_GAME_TEAM}`,
    formObj,
    authHeader()
  );
  return response;
}

async function deleteEventGameTeam(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.DELETE_EVENT_GAME_TEAM}`,
    formObj,
    authHeader()
  );
  return response;
}

async function getEventGameTeamPlayers(eventGameId) {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_EVENT_GAME_TEAM_PLAYERS}?EventGameId=${eventGameId}`,
    authHeader()
  );
  return response;
}

async function updateEventGameTeamPlayers(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.UPDATE_EVENT_GAME_TEAM_PLAYERS}`,
    formObj,
    authHeader()
  );
  return response;
}

async function getTeamRostersByEnum() {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_TEAM_ROSTERS}`,
    authHeader()
  );
  return response;
}

async function isDisplayTeamRosterByEnum() {
  const response = await APIHelper.get(
    `${APIURLConstants.IS_SHOW_TEAM_ROSTERS}`,
    authHeader()
  );
  return response;
}
